var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorySvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history-svgrepo-com 1",
    clipPath: "url(#clip0_66_192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96714 9.16396L4.98187 8.1492C5.29104 7.84002 5.79229 7.84002 6.10146 8.1492C6.41062 8.45834 6.41062 8.95963 6.10146 9.26877L3.72646 11.6438C3.57799 11.7922 3.37663 11.8757 3.16667 11.8757C2.9567 11.8757 2.75534 11.7922 2.60687 11.6438L0.231874 9.26877C-0.0772913 8.95963 -0.0772913 8.45834 0.231874 8.1492C0.541039 7.84002 1.04229 7.84002 1.35146 8.1492L2.38142 9.17915C2.5501 4.95595 6.0271 1.58398 10.2917 1.58398C14.664 1.58398 18.2083 5.12839 18.2083 9.50065C18.2083 13.8729 14.664 17.4173 10.2917 17.4173C7.80439 17.4173 5.58465 16.2693 4.13459 14.4774C3.85956 14.1375 3.91213 13.639 4.25202 13.364C4.5919 13.089 5.09039 13.1415 5.36543 13.4814C6.52779 14.9178 8.30245 15.834 10.2917 15.834C13.7895 15.834 16.625 12.9985 16.625 9.50065C16.625 6.00285 13.7895 3.16732 10.2917 3.16732C6.90683 3.16732 4.14217 5.82266 3.96714 9.16396ZM10.2917 3.95898C10.7289 3.95898 11.0833 4.31343 11.0833 4.75065V9.17274L13.2265 11.3159C13.5356 11.625 13.5356 12.1263 13.2265 12.4354C12.9173 12.7446 12.416 12.7446 12.1069 12.4354L9.73189 10.0604C9.58345 9.912 9.50001 9.7106 9.50001 9.50065V4.75065C9.50001 4.31343 9.85444 3.95898 10.2917 3.95898Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySvgrepoCom1);
export default __webpack_public_path__ + "static/media/history-svgrepo-com 1.556c6fe83de9243e74bb24b6837b625d.svg";
export { ForwardRef as ReactComponent };